import React, {useState} from 'react'
import './ProfileCreation.css'
import {useStore} from '../../StateManagement'
import CameraEnhanceIcon from '@material-ui/icons/CameraEnhance';
import {storage} from '../../Firebase/firebase'

function ProfileCreation() {
  const [stateData, dispatch] = useStore();
  const [name, setName] = useState('');
  const [about, setAbout] = useState('');
  const [profilePhotoUrl, setProfilePhotoUrl] = useState('');
  const [showProgress, setShowProgress] = useState({visible: false, width: 0})

  const handleSubmit = (e) => {
    e.preventDefault();

    // saving log in data to local storage
    const saveUserData = JSON.stringify({
      uid: stateData.userDetails.uid,
      phoneNumber: stateData.userDetails.phoneNumber,
      name,
      about,
      profilePhotoUrl
    });
    
    localStorage.setItem('loggedInUserInfo', saveUserData);

    // saving data to state
    dispatch({
      type: 'SET_USER',
      details: {
        uid: stateData.userDetails.uid,
        phoneNumber: stateData.userDetails.phoneNumber,
        name,
        about,
        profilePhotoUrl
      }
    })
  }

    const addPhotoToStorage = (file) => {
      let storageRef = storage.ref();
      let profilePhotoRef = `images/${stateData.userDetails.uid}`
      let uploadTask = storageRef.child(profilePhotoRef).put(file);

      // Register three observers:
      // 1. 'state_changed' observer, called any time the state changes
      // 2. Error observer,` called on failure
      // 3. Completion observer, called on successful completion
      uploadTask.on('state_changed', 
        (snapshot) => {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          if(progress > 0 && progress < 100){
            setShowProgress({visible: true, width: progress})
          }else{
            setShowProgress({visible: false, width: progress})
          }
        }, 
        (error) => {
          // Handle unsuccessful uploads
        }, 
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            setProfilePhotoUrl(downloadURL);
          });
        }
      );
    }

  const uploadPhoto = (e) => {
     const file = e.target.files[0];
     const validTypes = ['image/jpeg', 'image/jpg', 'image/svg', 'image/webp'];
     if(validTypes.includes(file.type)){
       addPhotoToStorage(file)
     }else{
       alert('invalid file: only svg, png, jpeg, webp and jpg files are supported')
     }
  }

  const profilePhotoStyle = profilePhotoUrl ? {backgroundImage: `url(${profilePhotoUrl})`} : {};

  return (
    <div className="profile__form">
      <div className="profile__form__container">
        <div className="modal">
          <div className="hero__section"></div>
          <div className="form__container">
            <form onSubmit={handleSubmit}>
              <label htmlFor="profile__photo"><div style={profilePhotoStyle}><CameraEnhanceIcon /></div></label>
              {showProgress.visible && <div className="progress">
                <div style={{width: `${showProgress.width}%`}} className="progress__indicator"></div>
              </div>}
              <input type="file" id="profile__photo" onChange={uploadPhoto} />
              <input type="text" value={stateData.userDetails.phoneNumber} readOnly={true} />
              <input type="text" placeholder="Name" required value={name} onChange={(e) => setName(e.target.value)} />
              <input type="text" placeholder="About" required value={about} onChange={(e) => setAbout(e.target.value)} />
              <button type="submit">Sign Up</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProfileCreation
